export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' }
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('table_label_goodsName') || 'SKU名称',
    field: 'goodsName',
    minWidth: 200,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' }
  },
  {
    title: that.$l('table_label_displaySpu') || 'SPU',
    minWidth: 200,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySpu' }
  },
  {
    title: that.$l('table_label_salesTitle') || '售卖标题',
    field: 'salesTitle',
    minWidth: 380,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesTitle' }
  },
  {
    title: that.$l('table_label_amzStoreName') || '店铺',
    field: 'amzStoreName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayStore' }
  },
  {
    title: that.$l('table_label_salesPrice') || '售卖价格',
    field: 'v_salesPrice',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPrice' }
  },
  {
    title: that.$l('table_label_operateName') || '运营人员',
    field: 'operateName',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_scmName') || '工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' }
  }
]
